import {
  ACCESS_TOKEN_LOCALSTORAGE_KEY,
  ApiStatus,
  REFRESH_TOKEN_COOKIE_KEY,
} from '@constants';
import Cookies from 'js-cookie';
import { auth } from 'services/firebase';

export function setRefreshToken(token: string | null) {
  if (typeof window != 'undefined') {
    token
      ? Cookies.set(REFRESH_TOKEN_COOKIE_KEY, token, {
          expires: 7,
        })
      : Cookies.remove(REFRESH_TOKEN_COOKIE_KEY);
  }
}

export function setAccessToken(token: string | null) {
  if (typeof window != 'undefined') {
    token
      ? localStorage.setItem(ACCESS_TOKEN_LOCALSTORAGE_KEY, token)
      : localStorage.removeItem(ACCESS_TOKEN_LOCALSTORAGE_KEY);
  }
}

export async function getAccessToken() {
  return await auth.currentUser?.getIdToken();
}

export const isStatusLoading = (status: ApiStatus) =>
  status === ApiStatus.LOADING;
export const isStatusComplete = (status: ApiStatus) =>
  status === ApiStatus.COMPLETE;

export const isStatusIdle = (status: ApiStatus) => status === ApiStatus.IDLE;
export const isStatusFailed = (status: ApiStatus) =>
  status === ApiStatus.FAILED;
export const isStatusForbidden = (status: ApiStatus) =>
  status === ApiStatus.FORBIDDEN;

export const isStatusFailedAny = (status: ApiStatus) =>
  status !== ApiStatus.COMPLETE &&
  status !== ApiStatus.IDLE &&
  status !== ApiStatus.LOADING;
